import { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from 'src/contexts/AuthContext';
import { OrganizationType } from 'src/types/organization.type';

type OrganizationContextType = {
   organization: OrganizationType | null;
};

const OrganizationContext = createContext<OrganizationContextType>({
   organization: null
});

export const OrganizationProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
   const { user, isOrgAdmin } = useAuth();
   const [organization, setOrganization] = useState<OrganizationType | null>(null);

   useEffect(() => {
      if (user && isOrgAdmin) {
         // Default set to first organization until switch
         user.organizations?.length && setOrganization(user.organizations?.[0])
      }
   }, [user, isOrgAdmin])

   return <OrganizationContext.Provider value={{ organization }}>{children}</OrganizationContext.Provider>;
};

// eslint-disable-next-line react-refresh/only-export-components -- co-located with its provider; splitting would ripple through every import site
export const useOrganization = () => {
   const context = useContext(OrganizationContext);
   if (!context) throw new Error('useOrganization must be used within OrganizationProvider');

   return context;
};
